var map = {
	".": 628,
	"./": 628,
	"./assets/CloudSolutions.jpg": 8429,
	"./assets/IT.png": 7756,
	"./assets/ITConsulting.jpg": 4181,
	"./assets/cyberSecurity.jpg": 3499,
	"./assets/web-dev.jpg": 830,
	"./index": 628,
	"./index.js": 628,
	"./style.css": 2219
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8629;